import * as React from 'react';
import { css, CSSProperties, StyleSheet } from 'aphrodite/no-important';

interface WrapperForSafariBorderRadiusBugProps {
    surfaceStyle: CSSProperties
}

const createStyle = () => StyleSheet.create({
  wrapper: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
});

export const WrapperForSafariBorderRadiusBug: React.FunctionComponent<WrapperForSafariBorderRadiusBugProps> = ({ surfaceStyle, children }) => {
  const style = createStyle();
  return (
    <div className={css(StyleSheet.create({ surfaceStyle }).surfaceStyle, style.wrapper)}>
      {children}
    </div>
  );
};
